import { render } from "./AttributionComponent.vue?vue&type=template&id=0df30ee2&scoped=true"
const script = {}

import "./AttributionComponent.vue?vue&type=style&index=0&id=0df30ee2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df30ee2"]])

export default __exports__